import { AbstractPlayableContent } from "../../playable/models/AbstractPlayableContent";
import { Division } from "../../playable/models/Division";
import { SoundParameters } from "../../player/models/parameters/SoundParameters";
import { getImageUrl } from '../../../utils/helpers';


export class MiniPlayerConfig {
  readonly divisions: Division[];
  readonly playableContent: AbstractPlayableContent;
  readonly soundParameters: SoundParameters;
  readonly autoLoop: boolean;
  private readonly _title: string | null;
  private readonly _subtitle: string | null;
  private readonly _image: string | null;

  constructor(divisions: Division[], playableContent: AbstractPlayableContent, soundParameters: SoundParameters, title: string | null = null, subtitle: string | null = null, image: string | null = null, autoLoop = false) {
    this.divisions = divisions;
    this.playableContent = playableContent;
    this.soundParameters = soundParameters;
    this.autoLoop = autoLoop;
    this._title = title;
    this._subtitle = subtitle;
    this._image = image;
  }

  get image(): string | null {
    if(this._image === 'rhythmicBloc') {
      return null
    }
    
    const image: string | null = this._image || this.playableContent.baseModel.piece.image
    return image ? getImageUrl(image) : null
  }
  get title(): string {
    return this._title ?? this.playableContent.baseModel.piece.title
  }
  get subtitle(): string {
    return this._subtitle ?? this.playableContent.baseModel.piece.artist
  }
}
